export const Brand = ({ compact = false, hideTextBelowSm = false }) => (
  <span data-testid="brand" className="flex items-center gap-3 min-w-0">
    <img
      src="/zdg-logo.png"
      alt="Zero Ducks Given logo"
      data-testid="brand-logo"
      className={`${compact ? "h-8" : "h-14 sm:h-16"} w-auto shrink-0 drop-shadow-sm transition-transform group-hover:-rotate-3`}
    />
    <span className={`${hideTextBelowSm ? "hidden sm:flex" : "flex"} flex-col leading-none text-left min-w-0`}>
      <span className={`font-heading font-bold tracking-tight ${compact ? "text-sm" : "text-xl sm:text-2xl"}`}>
        Duckify<span className="text-accent">3D</span>
      </span>
      <span data-testid="brand-byline" className={`font-mono2 uppercase tracking-widest text-muted-foreground ${compact ? "text-[9px]" : "text-[10px] sm:text-xs"} mt-1 truncate`}>
        by Zero Ducks Given
      </span>
    </span>
  </span>
);
